import { render, staticRenderFns } from "./ProductExclusion.vue?vue&type=template&id=f86b999c&scoped=true&"
import script from "./ProductExclusion.vue?vue&type=script&lang=js&"
export * from "./ProductExclusion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86b999c",
  null
  
)

export default component.exports